interface ParameterTypeMetadata {
  [parameterType: string]: string;
}

export const PARAM_TYPES: ParameterTypeMetadata = {
  FUNCTION: 'FUNCTION',
};
